import React, { createContext, useState, useContext, useEffect } from "react";

// --------------------------------------------------
// Context
// --------------------------------------------------
const KategorisierungContext = createContext();

// Custom hook
export const useKategorisierung = () => {
  const context = useContext(KategorisierungContext);
  if (!context)
    throw new Error("useKategorisierung must be used within KategorisierungProvider");
  return context;
};

// --------------------------------------------------
// Provider
// --------------------------------------------------
export const KategorisierungProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    const saved = localStorage.getItem("kategorisierung");
    if (saved) return JSON.parse(saved);

    return {
      linksRisikotyp: "",
      rechtsRisikotyp: "",
    };
  });

  // Persist on update
  useEffect(() => {
    localStorage.setItem("kategorisierung", JSON.stringify(data));
  }, [data]);

  // Optional clear function
  const clearKategorisierung = () => {
    setData({
      linksRisikotyp: "",
      rechtsRisikotyp: "",
    });
    localStorage.removeItem("kategorisierung");
  };

  return (
    <KategorisierungContext.Provider value={{ data, setData, clearKategorisierung }}>
      {children}
    </KategorisierungContext.Provider>
  );
};
